<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <div class="cv-chart" v-if="pieData.length > 0">
      <div class="cv-title">
        <div class="cv-title-item">
          <div class="cv-title-item__name">老人人口总数（万人）</div>
          <div class="cv-title-item__value">{{ population }}</div>
        </div>
        <div class="cv-title-item">
          <div class="cv-title-item__name">设施设备覆盖率</div>
          <div class="cv-title-item__value">{{ coverage }}</div>
        </div>
      </div>
      <v-chart ref="chart" :options="pieOption" @mouseover="onMouseOver" @globalout="onGlobalOut" autoresize></v-chart>
    </div>
    <div v-else class="cv-nodata">暂无数据!</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/legend'

export default {
  name: 'ElderStatis',
  computed: {
    ...mapGetters(['cid']),
    chart() {
      return this.$refs.chart && this.$refs.chart['chart']
    },
  },
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '老年人口数据统计',
    },
  },
  watch: {
    pieData(data) {
      this.pieOption.dataset.source = data
      this.$nextTick(() => {
        if (this.chart && !this.pieInterval) this.startAnimation()
      })
    },
  },
  data() {
    return {
      dataIndex: -1,
      coverage: '51%',
      population: 13.03,
      pieInterval: null,
      pieOption: {
        color: ['#004be3', '#e36b00', '#00e370', '#00afe3', '#e3db00', '#db00e3'],
        title: {
          show: false,
          top: 'top',
          left: '15%',
          text: '人口总数（万人）',
          subtext: '64.89',
          textAlign: 'center',
          textStyle: {
            color: '#fa7310',
            fontSize: 16,
          },
          subtextStyle: {
            color: '#00a4f0',
            fontSize: 30,
          },
        },
        legend: {
          show: true,
          top: 'middle',
          right: 'right',
          orient: 'vertical',
          itemWidth: 20,
          itemHeight: 10,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        dataset: {
          source: [],
        },
        series: [
          {
            type: 'pie',
            name: '老年人口数据统计',
            legendHoverLink: false,
            radius: ['65%', '85%'],
            label: {
              show: false,
              padding: [20, 0, 0],
              position: 'center',
              align: 'center',
              fontSize: 15,
              formatter: (params) => {
                return `${params.name}(万人)\n{num|${params.data.value}}`
              },
              emphasis: {
                show: true,
                fontSize: 15,
              },
              rich: {
                num: {
                  fontSize: 35,
                  lineHeight: 50,
                },
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: '#0096ff',
            },
            encode: {
              itemName: 'name',
              value: 'value',
            },
          },
        ],
      },
      pieData: [],
    }
  },
  created() {
    this.getElderStatisData()
  },
  beforeDestroy() {
    if (this.pieInterval) {
      clearInterval(this.pieInterval)
      this.pieInterval = null
    }
  },
  methods: {
    onMouseOver() {
      if (this.pieInterval) {
        this.chart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: this.dataIndex,
        })
        clearInterval(this.pieInterval)
        this.pieInterval = null
      }
    },
    onGlobalOut() {
      !this.pieInterval && this.startAnimation()
    },
    startAnimation() {
      const dataLen = this.pieData.length
      if (dataLen > 1) {
        this.pieInterval = setInterval(() => {
          this.chart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          })
          if (this.dataIndex < dataLen - 1) {
            this.dataIndex++
          } else {
            this.dataIndex = 0
          }
          this.chart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: this.dataIndex,
          })
        }, 3000)
      }
    },
    getElderStatisData() {
      this.$api
        .getElderServiceStatis()
        .then((res) => {
          if (!res) return
          // this.population = res.CityPersonCount
          this.pieData = [
            {
              name: '高龄',
              value: Number(res.CityPersonGLCount),
            },
            {
              name: '失能',
              value: Number(res.CityPersonSNCount),
            },
            {
              name: '残疾',
              value: Number(res.CityPersonCJCount),
            },
            {
              name: '空巢独居',
              value: Number(res.CityPersonKCCount),
            },
            {
              name: '特困及低保',
              value: Number(res.CityPersonTKCount),
            },
            {
              name: '计划生育特困',
              value: Number(res.CityPersonJHCount),
            },
          ]
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.cv-chart {
  position: relative;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }

  .cv-title {
    position: absolute;
    top: 0;
    left: 20px;

    &-item {
      + .cv-title-item {
        margin-top: 10px;
      }

      &__name {
        color: #fa7310;
        font-size: 16px;
      }

      &__value {
        margin-top: 5px;
        color: #00a4f0;
        font-size: 30px;
        font-weight: 600;
      }
    }
  }
}
</style>
